import {
    disableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock'

export default class Header {
    constructor (el) {
        this.el = el
        this.trigger = this.el.querySelector('.js-header-toggle')
        if (this.trigger) {
            this.initTrigger()
        }
    }

    initTrigger () {
        this.trigger.addEventListener('click', this.onClick.bind(this))
    }

    onClick () {
        const isActive = this.el.classList.contains('-active')
        isActive ? clearAllBodyScrollLocks() : disableBodyScroll(this.el)
        this.el.classList[isActive ? 'remove' : 'add']('-active')
    }
}
